<script>
import { mdiPlay, mdiPause } from "@mdi/js";
import { VImg, VBtn, VIcon } from "vuetify/lib";

export default {
    name: "TsImg",
    extends: VImg,
    components: {
        VBtn,
        VIcon,
        mdiPlay,
        mdiPause,
    },
    props: {
        tsClass: String,
        pause: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        genContent() {
            const self = this;
            const playIcon = this.$createElement(VIcon, mdiPlay);
            const pauseIcon = this.$createElement(VIcon, mdiPause);
            return self.showButton
                ? this.$createElement(
                      "div",
                      {
                          staticClass: "v-img__contents",
                      },
                      [
                          this.$createElement(
                              VBtn,
                              {
                                  props: {
                                      icon: true,
                                      xSmall: true,
                                      color: "rgba(0, 0, 0, 1)",
                                  },
                                  on: {
                                      click: function () {
                                          self.pauseAnimation();
                                      },
                                  },
                              },
                              [this.paused ? playIcon : pauseIcon]
                          ),
                      ]
                  )
                : "";
        },
        initCanvas() {
            const { image, paused } = this;
            const canvas = document.createElement("canvas");
            const width = this.$el.querySelector(
                ".v-image__image.v-image__image--contain"
            ).__vue__.$el.clientWidth;
            const height = this.$el.querySelector(
                ".v-image__image.v-image__image--contain"
            ).__vue__.$el.clientHeight;
            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d").drawImage(image, 0, 0, width, height);
            canvas.setAttribute("aria-hidden", "true");
            canvas.setAttribute("role", "presentation");
            canvas.style.setProperty("display", paused ? "" : "none");
            this.canvas = canvas;
            const el = this.$el.querySelector(
                ".v-image__image.v-image__image--contain"
            );
            el.insertBefore(canvas, null);
        },
        pauseAnimation() {
            this.$set(this, 'paused', !this.paused);
            console.log(this.paused)
            if (this.paused) {
                this.canvas.style.setProperty("display", "");
            } else {
                this.canvas.style.setProperty("display", "none");
            }
        },
        playPauseHandler() {},
    },
    data: function () {
        return {
            canvas: null,
            paused: this.pause,
            showButton: false,
        };
    },
    computed: {},
    mounted() {
        let self = this;
        this.$on("load", function () {
            setTimeout(() => {
                self.initCanvas();
            }, 1000);
        });
    },
    watch: {
        isLoading() {
            const self = this;
            if (!this.isLoading)
                this.$nextTick(() => {
                    setTimeout(function () {
                        self.showButton = true;
                    }, 1000);
                });
        },
    },
};
</script>
